import React, { Component } from 'react';
import PopupMenu from './PopupMenu';
import EdgeLocation from '../ui_core/EdgeLocation';
import Star from './Star';
import Spinner from './Spinner';
import './PlotMenu.css';
import UrlHelper from '../core/UrlHelper';
import Once from '../core/Once';
import ParameterErrors from '../errors/ParameterErrors';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import enableBindingToOthers from '../mvvm/enableBindingToOthers';
import Handles from '../core/Handles';
import { faStreetView} from '@fortawesome/free-solid-svg-icons';
import IconButton from './IconButton';
import PlotStatus from '../site/PlotStatus';
import Urls from '../urls/Urls';
import GroupedCallbacks from '../core/GroupedCallbacks';
import PlotMoreInformationType from '../enums/PlotMoreInformationType';
import HashSource from '../core/HashSource';
import isMobile from '../core/isMobile';
import stopEventPropagation from '../ui_core/stopEventPropagation';
import Tutorials from '../tutorials/Tutorials';
import TutorialMessage from '../tutorials/TutorialMessage';

const {throwNotProvided}=ParameterErrors;
const MIN_TIME_SHOW_SPINNER_MILLISECONDS=500;
const MAX_TIME_TO_LOAD_IMAGE_BEFORE_SPINNER_DELAY_REQUIRED=20; //This is so that if the image loads very fast because already cached the spinner is never seen.
const DELAY_BEFORE_SHOW_SPINNER_MILLISECONDS = 1000;
export default class PlotMenu extends Component {
	constructor(props){
		super(props)
		enableBindingToOthers(this);
		const {showPlotMoreInformation, onHide, addFavourite, removeFavourite,
		showStreetView, enterHouse, showBrochureGenerationDialog, showPlotDetailedInformation,
		showImagesFullScreen, configuration}=props;
		this._configuration = configuration;
		this._showPlotDetailedInformation  = showPlotDetailedInformation;
		this._showImagesFullScreen = showImagesFullScreen;
		this._star = React.createRef();
		this._imgRef= React.createRef();
		this._lhsRef= React.createRef();
		this._buttonShowStreetViewRef= React.createRef();
		this._floorPlansButtonRef= React.createRef();
		this._buttonGalleryRef= React.createRef();
		this._callbackOnHide=onHide;
		if(!showPlotMoreInformation)throwNotProvided('showPlotMoreInformation');
		this._callbackShowPlotMoreInformation = showPlotMoreInformation;
		this._callbackAddFavourite = addFavourite;
		this._callbackRemoveFavourite = removeFavourite;
		this._callbackShowStreetView = showStreetView;
		this._callbackEnterHouse = enterHouse;
		this._callbackShowBrochureGenerationDialog = showBrochureGenerationDialog;
		this._popupMenu = React.createRef();
		this.showIfIsLoaded= this.showIfIsLoaded.bind(this);
		this.setFilteredPlots= this.setFilteredPlots.bind(this);
		this._getFirstPlotMatchingFilteredPlots= this._getFirstPlotMatchingFilteredPlots.bind(this);
		this._handleClickMoreInfo= this._handleClickMoreInfo.bind(this);
		this._handleStarSelectedChanged = this._handleStarSelectedChanged.bind(this);
		this._handlePlotSelectedChanged = this._handlePlotSelectedChanged.bind(this);
		this._handleClickPreviousPlot = this._handleClickPreviousPlot.bind(this);
		this._handleClickNextPlot = this._handleClickNextPlot.bind(this);
		this._handleImageLoaded= this._handleImageLoaded.bind(this);
		this._handleImageError= this._handleImageError.bind(this);
		this._handlePopupMenuHide = this._handlePopupMenuHide.bind(this);
		this._handleClickShowGallery= this._handleClickShowGallery.bind(this);
		this._handleClickShowFloorPlan= this._handleClickShowFloorPlan.bind(this);
		this._handleClickMeaningShowPlotDetailedInformation= this._handleClickMeaningShowPlotDetailedInformation.bind(this);
		this._handleClickLHS= this._handleClickLHS.bind(this);
		this._getImgUrl= this._getImgUrl.bind(this);
		this._handleClickEnterHouse= this._handleClickEnterHouse.bind(this);
		this.show = this.show.bind(this);
		this.hide = this.hide.bind(this);
		this._releasePlotActiveHandle= this._releasePlotActiveHandle.bind(this);
		this._handleClickShowStreetView = this._handleClickShowStreetView.bind(this);
		this._handleClickSendBrochure = this._handleClickSendBrochure.bind(this);
		this._updateTutorialMessages = this._updateTutorialMessages.bind(this);
		this._groupedCallbackImageLoaded = new GroupedCallbacks();
		this._onceClicked = new Once(method=>method());
		this._currentPlotActiveHandle = null;
		this._startedShowAt = 0;
		this._loadingImageHandles = new Handles();
		this.state={siteJson:null, plot:null};
		PlotMenu.instance = this;
		Tutorials.addEventListener('update', this._updateTutorialMessages);
	}
	_updateTutorialMessages(){
		this._tutorialMessageFavourite?.dispose();
		this._tutorialMessageGoToOutside360?.dispose();
		this._tutorialMessagePlotMenuFloorPlans?.dispose();
		this._tutorialMessagePlotMenuGallery?.dispose();
		setTimeout(()=>{
			this._tutorialMessageFavourite?.dispose();
			this._tutorialMessageGoToOutside360?.dispose();
			this._tutorialMessagePlotMenuFloorPlans?.dispose();
			this._tutorialMessagePlotMenuGallery?.dispose();
			if(!this.state.plot)return;
			if(Tutorials.showStep3_2&&Tutorials.showing&&!Tutorials.hasClickedPlotMenuFavourites){
				this._tutorialMessageFavourite = new TutorialMessage({
					message:'Click to favourite', elementOn:this._star.current._elementRef.current,
					className:'tutorial-message-favourite',							
					hasClose:true, callbackClose:()=>{
						Tutorials.showing = false;
						this._tutorialMessageFavourite.dispose();
					},
					fixInPlace:true
				});
				Tutorials.addShowingTutorialMessage(this._tutorialMessageFavourite);
			}
			if(Tutorials.showStep3&&Tutorials.showing&&!Tutorials.hasClickedPlotMenuGallery){
				this._tutorialMessagePlotMenuGallery = new TutorialMessage({
					message:'Click to see gallery', 
					elementOn:this._buttonGalleryRef.current._elementRef.current,
					className:'tutorial-message-plot-menu-gallery',							
					hasClose:true, callbackClose:()=>{
						Tutorials.showing = false;
						this._tutorialMessagePlotMenuGallery.dispose();
					},
					fixInPlace:true
				});
				Tutorials.addShowingTutorialMessage(this._tutorialMessagePlotMenuGallery);
			}
			if(Tutorials.showStep3_1&&Tutorials.showing&&!Tutorials.hasClickedPlotMenuFloorPlans){
				this._tutorialMessagePlotMenuFloorPlans = new TutorialMessage({
					message:'Click to see floor plans', elementOn:this._floorPlansButtonRef.current._elementRef.current,
					className:'tutorial-message-floor-plans',							
					hasClose:true, callbackClose:()=>{
						Tutorials.showing = false;
						this._tutorialMessagePlotMenuFloorPlans.dispose();
					},
					fixInPlace:true
				});
				Tutorials.addShowingTutorialMessage(this._tutorialMessagePlotMenuFloorPlans);
			}
			if(Tutorials.showStep7&&this._configuration.outside360Enabled&&Tutorials.showing&&!Tutorials.hasClickedGoToOutside360){
				this._tutorialMessageGoToOutside360 = new TutorialMessage({
					message:'Click to go to plot on outside 360', 
					elementOn:this._buttonShowStreetViewRef.current._elementRef.current, 
					rightAlign:true,
					className:'tutorial-message-plot-menu-outside-360',
					hasClose:true, callbackClose:()=>{
						Tutorials.showing = false;
						this._tutorialMessageGoToOutside360.dispose();
					},
					fixInPlace:true
				});
				Tutorials.addShowingTutorialMessage(this._tutorialMessageGoToOutside360);
			}
		});
	}
	show({position, getMouseInSourceBounds, siteJson, plot, unit, untilClickOff}){
		document.body.classList.remove('not-showing-plot-menu');
		this._tutorialMessageFavourite?.dispose();
		this._tutorialMessageGoToOutside360?.dispose();
		this._tutorialMessagePlotMenuFloorPlans?.dispose();
		this._tutorialMessagePlotMenuGallery?.dispose();
		Tutorials.plotMenuShowing=true;
		return new Promise((resolve, reject)=>{
			if(!plot)throwNotProvided('plot');
			if(plot.unit.plots.length>1){
				plot = this._getFirstPlotMatchingFilteredPlots(plot.unit.plots);
			}
			if(!siteJson)throwNotProvided('siteJson');
			this._currentLoadingImageHandle?.dispose();
			this.setState({siteJson:siteJson, plot:plot});
			this._imgRef.current.src='';
			this._imgRef.current.src = this._getImgUrl(plot);
			this._plot = plot;
			this._popupMenu.current.show({position:position, 
				getMouseInSourceBounds:getMouseInSourceBounds, untilClickOff});
			this._releasePlotActiveHandle();
			this._currentPlotActiveHandle?.dispose();
			this._currentPlotActiveHandle=plot.unit.takeActiveHandle();
			this._startedShowAt = new Date().getTime();
			let imgLoaded = false;
			const whenImgLoaded = ()=>{
				imgLoaded = true;
				this._currentLoadingImageHandle?.dispose();
			};
			setTimeout(()=>{
				if(imgLoaded) return;
				this._currentLoadingImageHandle?.dispose();
				this._currentLoadingImageHandle = this._loadingImageHandles.take();
			}, DELAY_BEFORE_SHOW_SPINNER_MILLISECONDS);
			this._groupedCallbackImageLoaded.then(()=>{
				whenImgLoaded();
				resolve();
			}).catch((err)=>{
				whenImgLoaded();
				reject(err);
			});
		});
	}
	showIfIsLoaded(){
		if((!this.state.siteJson)||(!this.state.plot))return;
		Tutorials.plotMenuShowing=true;
		this._popupMenu.current.showInExistingPosition();
	}
	hide(){
		this._tutorialMessageFavourite?.dispose();
		this._tutorialMessageGoToOutside360?.dispose();
		this._tutorialMessagePlotMenuFloorPlans?.dispose();
		this._tutorialMessagePlotMenuGallery?.dispose();
		document.body.classList.add('not-showing-plot-menu');
		this._popupMenu.current.hide();
	}
	setFilteredPlots(value){
		this._filteredPlots = value;
	}
	_getFirstPlotMatchingFilteredPlots(plots){
		if(!this._filteredPlots)return plots[0];
		const plotsMatchingFilteredPlots = [];
		for(var plot of plots){
			if(this._filteredPlots.indexOf(plot)>=0)
				plotsMatchingFilteredPlots.push(plot);
		}
		if(plotsMatchingFilteredPlots.length>0)
		{
			const availablePlots = plotsMatchingFilteredPlots.filter(plot=>plot.status===PlotStatus.AVAILABLE);
			if(availablePlots.length>0)
				return availablePlots[0];
			const comingSoonPlots = plotsMatchingFilteredPlots.filter(plot=>plot.status===PlotStatus.COMING_SOON);
			if(comingSoonPlots.length>0)
				return comingSoonPlots[0];
		}
		return plots[0];
	}
	_getImgUrl(plot){
		const relativePath = plot.unit.frontViewImage.getBestEntryToFitWidth(160).relativePath;
		return `${Urls.getAssetsForSite(this._configuration.siteSlug)}${UrlHelper.removeStartSlash(relativePath)}`;
	}
	_handlePopupMenuHide(){
		//this.setState({plot:null});
		Tutorials.plotMenuShowing=false;
		this._currentLoadingImageHandle?.dispose();
		this._callbackOnHide&&this._callbackOnHide();
		this._releasePlotActiveHandle();
		this._tutorialMessageFavourite?.dispose();
		this._tutorialMessageGoToOutside360?.dispose();
		this._tutorialMessagePlotMenuFloorPlans?.dispose();
		this._tutorialMessagePlotMenuGallery?.dispose();
	}
	_handleClickMoreInfo(e){
		this._stopEventPropagation(e);
		this._callbackShowPlotMoreInformation(this.state.plot);
	}
	_handleStarSelectedChanged(selected){
		Tutorials.hasClickedPlotMenuFavourites=true;
		this._tutorialMessageFavourite?.dispose();
		this._tutorialMessageGoToOutside360?.dispose();
		this._tutorialMessagePlotMenuFloorPlans?.dispose();
		this._tutorialMessagePlotMenuGallery?.dispose();
		this._stopEventPropagation();
		if(selected)this._callbackAddFavourite(this.state.plot);
		else this._callbackRemoveFavourite(this.state.plot);
	}
	_handlePlotSelectedChanged(value){
		if(this._star.current)
			this._star.current.selected=value;
	}
	_handleImageLoaded(){
		this._imgLoading = false;
		const timeShownSpinnerForMilliseconds = new Date().getTime()-this._startedShowAt;
		//let timeLeftBeforeHideSpinner=0;
		this._groupedCallbackImageLoaded.doThen();
		/*if(timeShownSpinnerForMilliseconds<=MAX_TIME_TO_LOAD_IMAGE_BEFORE_SPINNER_DELAY_REQUIRED)
			timeLeftBeforeHideSpinner= 0;
		else
		{	
			timeLeftBeforeHideSpinner = MIN_TIME_SHOW_SPINNER_MILLISECONDS - timeShownSpinnerForMilliseconds;
			if(timeLeftBeforeHideSpinner<0)timeLeftBeforeHideSpinner=0;
		}*/
		/*this._currentLoadingImageHandle?.dispose();
		setTimeout(()=>{
		}, timeLeftBeforeHideSpinner);*/
	}
	_handleImageError(e){
		this._groupedCallbackImageLoaded.doCatch(e);
	}
	_handleClickShowStreetView(e){
		Tutorials.hasClickedGoToOutside360=true;
		this._tutorialMessageFavourite?.dispose();
		this._tutorialMessageGoToOutside360?.dispose();
		this._tutorialMessagePlotMenuFloorPlans?.dispose();
		this._tutorialMessagePlotMenuGallery?.dispose();
		this._stopEventPropagation(e);
		this.hide();
		this._callbackShowStreetView({nearPlot:this.state.plot});
	}
	_handleClickShowGallery(e){
		this._onceClicked.trigger(()=>{
			this._stopEventPropagation(e);
			if(!this._configuration.plotMenuHasCloseButton)
				this.hide();
			this._callbackShowPlotMoreInformation(this.state.plot, PlotMoreInformationType.GALLERY);
		});
	}
	_handleClickShowFloorPlan(){
		this._onceClicked.trigger(()=>{
			if(!this._configuration.plotMenuHasCloseButton)
				this.hide();
			this._callbackShowPlotMoreInformation(this.state.plot, PlotMoreInformationType.FLOOR_PLANS);
		});
	}
	_handleClickEnterHouse(e){
		
		this._stopEventPropagation(e);
		if(!this._configuration.plotMenuHasCloseButton)
			this.hide();
		Tutorials.closeAll();
		this._callbackEnterHouse(this.state.plot);
	}
	_handleClickSendBrochure(e){
		this._stopEventPropagation(e);
		this.hide();
		this._callbackShowBrochureGenerationDialog({plot:this._plot});
	}
	_handleClickPreviousPlot(e){
		this._stopEventPropagation();
		const currentPlot = this.state.plot;
		const unit = currentPlot.unit;
		if(!unit)return;
		const plots = unit.plots;
		let nextIndex = plots.indexOf(currentPlot)-1;
		if(nextIndex<0)
			nextIndex=plots.length-1;
		this._plot=plots[nextIndex];
		this.setState({plot:this._plot});
	}
	_handleClickNextPlot(e){
		this._stopEventPropagation();
		const currentPlot = this.state.plot;
		const unit = currentPlot.unit;
		if(!unit)return;
		const plots = unit.plots;
		let nextIndex = plots.indexOf(currentPlot)+1;
		if(nextIndex>=plots.length)
			nextIndex=0;
		this._plot=plots[nextIndex];
		this.setState({plot:this._plot});
	}
	_handleClickMeaningShowPlotDetailedInformation(e){
		this._onceClicked.trigger(()=>{
			if(!this._configuration.showPlotDetailedInformationOnClickPlotMenu)return;
			this._stopEventPropagation();
			this.hide();
			this._showPlotDetailedInformation(this._plot);
		});
	}
	_handleClickLHS(){
		const plot = this.state.plot;
		let dynamicImages = [];
		this._stopEventPropagation();
		const frontViewImage = plot.unit.frontViewImage;
		if(frontViewImage){
			dynamicImages.push(frontViewImage);
		}
		const streetViewImage = plot.unit.streetViewImage;
		if(streetViewImage)
			dynamicImages.push(streetViewImage);
		plot.rooms.getArray().forEach((room)=>{
			dynamicImages = dynamicImages.concat(room.images);
		});
		this._showImagesFullScreen(dynamicImages);
	}
	_stopEventPropagation(e){
		if(!e)e=window.event;
		e.stopPropagation&&e.stopPropagation();
		e.preventDefault&&e.preventDefault();
	}
	_releasePlotActiveHandle(){
		if(!this._currentPlotActiveHandle)return;
		this._currentPlotActiveHandle.dispose();
		this._currentPlotActiveHandle=null;
	}
	componentDidUpdate(previousProps, previousState){
		const oldPlot = previousState.plot;
		const newPlot = this.state.plot;
		this.myBindings.reset();
		if(newPlot){
			PropertyBindingFactory.standard(this, newPlot, 'selected', this._handlePlotSelectedChanged);
		}
	}
	render(){
		this._tutorialMessageFavourite?.dispose();
		this._tutorialMessageGoToOutside360?.dispose();
		this._tutorialMessagePlotMenuFloorPlans?.dispose();
		this._tutorialMessagePlotMenuGallery?.dispose();
		const hasOneOrMoreRoomImages=this.state.plot&&this.state.plot.hasOneOrMoreRoomImages;
		const hasFloorPlans = this.state.plot&&this.state.plot.floorPlanImages&&this.state.plot.floorPlanImages.length>0;
		if(!hasOneOrMoreRoomImages)
		{
			Tutorials.hasClickedPlotMenuGallery = true;
		}
		if(!hasFloorPlans)
		{
			Tutorials.hasClickedPlotMenuFloorPlans = true;
		}
		const nBathroomString = this._configuration.showNBathrooms?` and ${this._plot?.nBathrooms} Bathrooms`:'';
		const buttons = [];
		if(this._configuration.showMoreInformation)
			buttons.push((<button key={HashSource.next()} className="button-more-info" onClick={this._handleClickMoreInfo}>More Information</button>));
		else{
			const hasConfiguratorOrTour=this.state.plot&&Urls.getConfiguratorUrlForPlot(this.state.plot, this._configuration);
			if(hasConfiguratorOrTour)
				buttons.push((<button key={HashSource.next()} className="button-enter-house" onClick={this._handleClickEnterHouse}>Enter Plot</button>));
			const brochureEnabled =this.state.plot?.houseType?( this.state.plot.houseType.brochureEnabled!==false):true;
			if(this._configuration.brochureGeneratorUrl&&brochureEnabled){
				buttons.push((<button key={HashSource.next()} className="button-send-brochure" onClick={this._handleClickSendBrochure}>Send Brochure</button>));
				
			}
			if(this.state.plot?.unit.plots.length>1){	
				buttons.push((<button key={HashSource.next()} className="button-previous-plot" onClick={this._handleClickPreviousPlot}>Previous Plot</button>));
				buttons.push((<button key={HashSource.next()} className="button-next-plot" onClick={this._handleClickNextPlot}>Next Plot</button>));
			}
		}
		const showPrice = (this.state.plot)&&(this.state.plot.isAvailable);//(!this.state.plot.isSold)&&(!this.state.plot.isReserved)&&(!this.state.plot.isExchanged);
		let classNameStatus = 'status ';
		if(this.state.plot)
			classNameStatus+=PlotStatus.getCssName(this.state.plot.status);
		const nBedrooms = this._configuration.hideNBedrooms?null:(
			<div className="n-bedrooms">{this.state.plot?.nBedrooms} Bedrooms {nBathroomString}</div>);
			const buttonShowStreetView = 
				this._configuration.outside360Enabled?(<IconButton className="button-show-street-view button-show"
				imgUrl={Urls.assets+'icons/UI_Button_Walkmode.png'} onClick={this._handleClickShowStreetView} ref={this._buttonShowStreetViewRef}></IconButton>):null;
			const floorPlansButton = hasFloorPlans? (
				<IconButton tooltip="FloorPlan" ref={this._floorPlansButtonRef} className="button-show-floor-plan button-show" imgUrl={Urls.assets+'icons/UI_Button_Floorplan.png'} onClick={this._handleClickShowFloorPlan}></IconButton>):null;
				const hasCloseButton = this._configuration.plotMenuHasCloseButton;
				const closeButton = hasCloseButton?(<IconButton className="button-show-floor-plan button-close" 
					imgUrl={Urls.assets+'icons/UI_Button_Exit.png'} onClick={(e)=>{
						e.stopPropagation();
						this.hide(e);
					}}></IconButton>):null;
				let className ="plot-menu";
				if(hasCloseButton)
					className+=" has-close-button";
				this._updateTutorialMessages();
		const abovePriceHtml =this.state.plot?this.state.plot.abovePriceHtml:'';
		const priceString = (!showPrice)||(this.state.plot.price<=0)?' ':this.state.plot.priceString+(this.state.plot.endOfPriceTextSnippet?` ${this.state.plot.endOfPriceTextSnippet}`:'');
		return (<PopupMenu className={className} edgeLocation={EdgeLocation.BOTTOM_CENTER} ref ={this._popupMenu} onHide={this._handlePopupMenuHide} >
	<div className="plot-menu-inner">
	<div className="about">
		<div className="lhs" ref={this._lhsRef} onClick={this._handleClickLHS}>
			<img ref={this._imgRef}onLoad={this._handleImageLoaded} onError={this._handleImageError}></img>
			<Spinner spinnerHandles ={this._loadingImageHandles} invertHandles={false}></Spinner>
		</div>
		<div className="rhs" onClick={this._handleClickMeaningShowPlotDetailedInformation}>
			{closeButton}
			<div className="name">{this.state.plot?.name}</div>
			<div className="plot">Plot 	{this.state.plot?.number}</div>
			<div className={classNameStatus}> {this.state.plot?PlotStatus.getDescription(this.state.plot.status):'&nbsp;'}</div>
			<div className="above-price-html" dangerouslySetInnerHTML={{__html: abovePriceHtml}}/>
			<div className="price"> {priceString}</div>
				{nBedrooms}
			<div className="small-buttons">
				<Star onSelectedChange={this._handleStarSelectedChanged} tooltip="Favourite"
				ref={this._star} stopEventPropagation={true}></Star>
					{buttonShowStreetView}
				<IconButton ref={this._buttonGalleryRef} className="button-show-gallery button-show" tooltip="Gallery" imgUrl={hasOneOrMoreRoomImages?(Urls.assets+'icons/UI_Button_Gallery.png'):(Urls.assets+'icons/UI_Button_Gallery_Disabled.png')}
				onClick={hasOneOrMoreRoomImages?this._handleClickShowGallery:()=>{}}></IconButton>
					{floorPlansButton}
			</div>
		</div>
	</div>
		<div className="buttons">
			{buttons}
		</div>
	</div>
	<div className="plot-menu-triangle"></div>	
		</PopupMenu>)
	}
}
